import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Users, Building, LogOut } from 'lucide-react';
import { signOut } from '../../lib/auth';

const Dashboard = () => {
  const handleSignOut = async () => {
    await signOut();
  };

  const sections = [
    {
      title: 'Agenda',
      description: 'Gérer les événements',
      icon: Calendar,
      to: '/agenda',
    },
    {
      title: 'Comité',
      description: 'Gérer les membres du comité',
      icon: Users,
      to: '/who-we-are',
    },
    {
      title: 'Partenaires',
      description: 'Gérer les partenaires et sponsors',
      icon: Building,
      to: '/partners',
    },
  ];

  return (
    <div className="min-h-screen bg-beige">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-12">
          <h1 className="text-4xl font-serif font-bold text-dark">Administration</h1>
          <button
            onClick={handleSignOut}
            className="flex items-center gap-2 px-4 py-2 text-dark/80 hover:text-dark"
          >
            <LogOut className="h-5 w-5" />
            Déconnexion
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sections.map((section) => {
            const Icon = section.icon;
            return (
              <Link
                key={section.title}
                to={section.to}
                className="bg-white rounded-lg shadow-lg p-6 hover:transform hover:scale-105 transition-all duration-300"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="bg-dark text-beige p-3 rounded-lg">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h2 className="text-xl font-bold text-dark">{section.title}</h2>
                </div>
                <p className="text-dark/80">{section.description}</p>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;